import { IQuestion } from 'app/interfaces/IQuestion'
import { IRow } from 'app/interfaces/IRow'
import { ViewerTypeEnum } from 'app/enums/ViewerTypeEnum'

type QuestionWithMatrixRows = IQuestion & {
  rows?: Record<string, IRow>
  rowsOrder?: string[]
}

/** Info questions (name / address / email / phone) are matrix-based but templates from the builder
 * sometimes omit rows / rowsOrder until formatQuestion runs. This mirrors the builder's row wiring. */
const INFO_MATRIX_VIEWER_TYPES: ViewerTypeEnum[] = [
  ViewerTypeEnum.ADDRESS,
  ViewerTypeEnum.PHONE,
  ViewerTypeEnum.NAME,
  ViewerTypeEnum.EMAIL,
]

export function normalizeInfoMatrixQuestion(question: IQuestion): void {
  const q = question as QuestionWithMatrixRows
  if (!INFO_MATRIX_VIEWER_TYPES.includes(q.viewerType)) {
    return
  }
  if (q.rowsOrder?.length && q.rows && Object.keys(q.rows).length > 0) {
    return
  }
  const statementsOrder = q.statementsOrder
  if (!statementsOrder?.length || !q.statements) {
    return
  }

  const rowKey = `info_row_${q.key.replace(/[^a-zA-Z0-9_]/g, '_')}`
  const openCols = statementsOrder.reduce<Record<string, boolean>>((acc, sKey) => {
    acc[sKey] = true
    return acc
  }, {})

  const row: IRow = {
    key: rowKey,
    positionLocked: false,
    label: q.shortLabel || { fr: '', en: '' },
    openCols,
    isOpen: true,
    color: '',
  }

  q.rows = { [rowKey]: row }
  q.rowsOrder = [rowKey]

  q.minAnswers = {
    statements: q.minAnswers?.statements ?? 0,
    rows: q.minAnswers?.rows ?? 1,
  }
  q.maxAnswers = {
    statements: q.maxAnswers?.statements ?? statementsOrder.length,
    rows: q.maxAnswers?.rows ?? 1,
  }
}
